import {requirePermission} from '@/modules/auth/permissions'
import {CompaniesFilters} from '@/modules/products/companies/components'
import {ResourcesIndexPageHeader} from '@/shared/components/ui/resources-index-page-header'
import {createFileRoute} from '@tanstack/react-router'

export const Route = createFileRoute('/configuration/products/companies/')({
  beforeLoad: requirePermission('basic_data.manage'),
  component: CompaniesPage,
})

function CompaniesPage() {
  return (
    <>
      <ResourcesIndexPageHeader addNewTo="/configuration/products/companies/new">
        <CompaniesFilters />
      </ResourcesIndexPageHeader>
      table
    </>
  )
}
